import React from 'react';
import merge from 'classnames';

import { RadioButton } from '@/components/generic/RadioButton';
import { OrderBlockWrapper } from '@/components/modals/SubmitOrder/components/Common/OrderBlockWrapper';
import { useOrderDispatch } from '@/components/modals/SubmitOrder/helpers';

import { Props } from './types';

import styles from './PartialReRoof.module.scss';

export const PartialReRoof = ({ isPartialReRoof }: Props) => {
  const dispatch = useOrderDispatch();
  const isPartialReRoofDeselected = isPartialReRoof === null;
  const isYesSelected = Boolean(isPartialReRoof);
  const isNoSelected = !(isPartialReRoofDeselected || isPartialReRoof);

  const handlePartialReRoof = (partialReRoof: boolean): void => {
    dispatch({
      type: 'UPDATE_ORDER',
      payload: {
        partialReRoof,
      },
    });
  };
  const onYesButtonClick = () => {
    handlePartialReRoof(true);
  };

  const onNoButtonClick = () => {
    handlePartialReRoof(false);
  };

  return (
    <OrderBlockWrapper>
      <div className={styles.reroof_wrapper}>
        <div className={styles.reroof_content_block}>
          <span className={styles.asterisk}>*</span>
          <div className={styles.reroof_content_wrapper}>
            <span className={styles.reroof_title}>Is this a partial roof replacement?</span>
            <span className={styles.subtitle}>(required)</span>

            <div className={styles.reroof_buttons}>
              <div
                className={styles.reroof_button}
                data-testid="partial-reroof-yes"
                onClick={onYesButtonClick}
              >
                <RadioButton
                  className={merge({ [styles.radio_button_selected]: isYesSelected })}
                  selected={isYesSelected}
                />
                <span className={styles.button_label}>Yes</span>
              </div>

              <div
                className={styles.reroof_button}
                data-testid="partial-reroof-no"
                onClick={onNoButtonClick}
              >
                <RadioButton
                  className={merge({ [styles.radio_button_selected]: isNoSelected })}
                  selected={isNoSelected}
                />
                <span className={styles.button_label}>No</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </OrderBlockWrapper>
  );
};
